<script setup>
definePage({
  meta: {
    layout: 'blank',
  },
})
</script>

<template>
  <div class="content">
    <div class="ma-5">
      Great! You've found the BubatzBauer playground...now what? Well I guess, unless you're a developer testing something,
      there isn't quite much here for you. Go checkout our ganja products instead! Happy smoking! ;-)
    </div>

    <VDivider />
  </div>
</template>

